<template>
<div class="chapter">
<div class="inner_page">
      ﻿

 
 
 
 
 
 <link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town</title>
<div class="image">
<p class="ser" id="pAVV"><img alt="images/img-12-1.jpg" id="AVV" src="images/img-12-1.jpg"/></p>
<p class="txcc" id="pA1Z"><i>Sipping with both barrels</i> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter07.vue?7f269613